import { useSelector } from '@redux';
import { Card, Space } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';
import isNull from 'lodash/isNull';
import { TRANSFER_ORDER_STATUS } from 'constants/constants';
import { useTranslation } from 'react-i18next';

const RelatedOrders = ({ data }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  const locationCodes = user?.locationCode?.split(',') || [];
  return (
    <Card title="Related Order">
      <Space size={10} className="w-full" direction="vertical">
        <div className="color-dark-gray font-medium">Transfer Orders ID</div>
        {data?.transferOrders?.length > 0 &&
          data?.transferOrders?.map((item) => (
            <Space
              key={item?.id}
              size={5}
              direction="vertical"
              className="w-full"
            >
              <div className="flex justify-between items-center">
                <div
                  key={item?.id}
                  onClick={() =>
                    (locationCodes?.includes(item?.fromWarehouseId) ||
                      isNull(user?.locationCode)) &&
                    navigate(`/transfer-orders/${item?.id}/show`)
                  }
                  className="cursor-pointer text-highlight"
                >
                  #{item?.toId || item?.id}
                </div>
                <div
                  className={`font-semibold ${TRANSFER_ORDER_STATUS['AWAITING_CONFIRMATION']?.textColor}`}
                >
                  {t(TRANSFER_ORDER_STATUS[item?.status]?.text)}
                </div>
              </div>
            </Space>
          ))}
      </Space>
    </Card>
  );
};

export default RelatedOrders;
